var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showView)?_c('div',{staticClass:"views-forum"},[(_vm.showRules)?_c('rule-community',{on:{"hide-rules":function($event){_vm.showRules = false}}}):_c('categories-forum')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }